import { render, staticRenderFns } from "./DeleteArticleCalculation.vue?vue&type=template&id=2234ee6f"
import script from "./DeleteArticleCalculation.vue?vue&type=script&lang=js"
export * from "./DeleteArticleCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports